import { gql } from "@apollo/client";



export const GET_ORGANIZATION_CHART = gql`
  query OrganizationChart($orgId: Int) {
    organizationChart(orgId: $orgId) {
      orgChartData
    }
  }
`;
